/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

export const LOAD_APP = 'MFE/MBP/CHECKOUT/LOAD_APP';
export const SET_BRAND_CONFIG = 'MFE/MBP/CHECKOUT/SET_BRAND_CONFIG';
export const SET_FEATURE_FLAG = 'MFE/MBP/CHECKOUT/SET_FEATURE_FLAG';
export const SET_RELATIONSHIP_LIST = 'MFE/MBP/CHECKOUT/SET_RELATIONSHIP_LIST';

export const SET_RECIPIENT_TYPE = 'MFE/MBP/CHECKOUT/SET_RECIPIENT_TYPE';
export const CLEAR_RECIPIENT_TYPE = 'MFE/MBP/CHECKOUT/CLEAR_RECIPIENT_TYPE';

export const SET_RECAPTCHA_CHECKOUT_V2_TOKEN = 'MFE/MBP/CHECKOUT/SET_RECAPTCHA_CHECKOUT_V2_TOKEN';
export const CLEAR_RECAPTCHA_CHECKOUT_V2_TOKEN = 'MFE/MBP/CHECKOUT/CLEAR_RECAPTCHA_CHECKOUT_V2_TOKEN';

export const SET_IS_AUTH0_TRIGGER_CALLED = 'MFE/MBP-CHECKOUT/AUTH0/SET_IS_AUTH0_TRIGGER_CALLED';

export const SHORTENED_SALEFORCE_AB_TEST = 'MFE/MBP-CHECKOUT/ABTEST/SHORTENED_SALEFORCE_AB_TEST';

export const MIDDLE_PLACE_ORDER_SALEFORCE_AB_TEST = 'MFE/MBP-CHECKOUT/ABTEST/MIDDLE_PLACE_ORDER_SALEFORCE_AB_TEST';

export const ONE_PAGE_CHECKOUT_SALEFORCE_AB_TEST = 'MFE/MBP-CHECKOUT/ABTEST/ONE_PAGE_CHECKOUT_SALEFORCE_AB_TEST';

export const REMEMBER_ME_SALEFORCE_AB_TEST = 'MFE/MBP-CHECKOUT/ABTEST/REMEMBER_ME_SALEFORCE_AB_TEST';

export const CALENDAR_MESSAGE_AB_TEST = 'MFE/MBP-CHECKOUT/ABTEST/CALENDAR_MESSAGE_AB_TEST';

export const MODAL_QAS_RADIO_BUTTONS_SALEFORCE_AB_TEST = 'MFE/MBP-CHECKOUT/ABTEST/MODAL_QAS_RADIO_BUTTONS_SALEFORCE_AB_TEST';
export const CHECK_UNVERIFIED_ADDRESSES_SALEFORCE_AB_TEST = 'MFE/MBP-CHECKOUT/ABTEST/CHECK_UNVERIFIED_ADDRESSES_SALEFORCE_AB_TEST';
export const DELIVERY_DATE_SELECTIONS_SALESFORCE_AB_TEST = 'MFE/MBP-CHECKOUT/ABTEST/DELIVERY_DATE_SELECTIONS_SALESFORCE_AB_TEST';
export const LONGER_PASSPORT_MESSAGE_SALESFORCE_AB_TEST = 'MFE/MBP-CHECKOUT/ABTEST/LONGER_PASSPORT_MESSAGE_SALESFORCE_AB_TEST';
export const ENTERPRISE_CALENDAR_SALESFORCE_AB_TEST = 'MFE/MBP-CHECKOUT/ABTEST/ENTERPRISE_CALENDAR_SALESFORCE_AB_TEST';
export const DELIVERY_TIME_WINDOW_SALESFORCE_AB_TEST = 'MFE/MBP-CHECKOUT/ABTEST/DELIVERY_TIME_WINDOW_SALESFORCE_AB_TEST';
export const SET_NEW_PRODUCT_CARD_LAYOUT_ENABLED = 'MFE/MBP-CHECKOUT/ABTEST/SET_NEW_PRODUCT_CARD_LAYOUT_ENABLED';
export const CARDISLE_GRID_VIEW_SALEFORCE_AB_TEST = 'MFE/MBP-CHECKOUT/ABTEST/CARDISLE_GRID_VIEW_SALEFORCE_AB_TEST';
export const ORDER_SUMMARY_REMAPPING_SALESFORCE_AB_TEST = 'MFE/MBP-CHECKOUT/ABTEST/ORDER_SUMMARY_REMAPPING_SALESFORCE_AB_TEST';

export default {};
